/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Button } from "../../../components";
import { images } from "../../../config/images";
import {
  GetBookedCourtDetail,
} from "../../../utilities/api/courtBooking";
import { ToastContainer, toast } from "react-toastify";
import { QRCodeSVG } from "qrcode.react";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { LableFromEnums } from "../../../utilities";

const CourtsBookingSummary = (props: any) => {
  const { newRef } = props;
  const id = useLocation().state;
  const [bookingDetails, setBookingDetails] = useState<any>({});
  const [printing, setPrinting] = useState(false);
  const [totalTax, setTotalTax] = useState(0);
  const { Enums } = useAppSelector((state) => state.enumsArray);
  let EnumArrObj = { ...Enums };
  const ComponentRef = useRef<HTMLDivElement>(null);

  const GetData = async () => {
    const result = await GetBookedCourtDetail(id);
    if (result?.statusCode === 200) {
      let getTotalTax = 0;

      result.data?.bookingTaxes.forEach((_tax: any) => {
        getTotalTax += _tax?.percentage;
      });

      setTotalTax(getTotalTax);
      setBookingDetails(result.data);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetData();
  }, [ComponentRef]);

  const handlePrint = () => {
    setPrinting(true);
    window.open(
      "/printing/?type=summary&prefix=CB&id=" + bookingDetails.id + "&hash=" + bookingDetails?.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);
  };

  return (
    <Container fluid className="g-0">
      <Card>
        <Card.Body>
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Court Booking Summary </Card.Title>
            <Button
              onClick={handlePrint}
              type="button"
              className="btn btn-light rounded-1 me-3"
              bname={printing ? "Printing" : "Print"}
              name="print"
              id="print"
              disabled={printing}
            ></Button>
          </div>
          <div ref={newRef ? newRef : ComponentRef} className="print-content">
            <Row>
              {bookingDetails?.status !== "pending" && (
                <Col lg={3} className="g-0">
                  <div className="align-items-center d-flex flex-column pt-3">
                    <div className="qr-img">
                      <QRCodeSVG
                        value={JSON.stringify(bookingDetails.id)}
                        size={200}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        imageSettings={{
                          src: images.powerplayicon.default,
                          x: undefined,
                          y: undefined,
                          height: 30,
                          width: 30,
                          excavate: true,
                        }}
                      />
                    </div>
                    <small className="text-uppercase text-muted mt-3">
                      Booking ID
                    </small>
                    <span className="fw-semibold ">{bookingDetails?.id}</span>
                  </div>
                </Col>
              )}
              <Col lg={"9"}>
                <div className="court-booking-details  ps-5 pb-5">
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Name
                      </span>
                      <span className="user-info">
                        {bookingDetails?.user?.firstName}{" "}
                        {bookingDetails?.user?.lastName}{" "}
                      </span>
                    </Col>
                    {bookingDetails.bookingType !== "individual" && (
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          {LableFromEnums(
                            bookingDetails?.bookingType,
                            EnumArrObj
                          )}{" "}
                          Name
                        </span>
                        <span className="user-info">
                          {bookingDetails?.companyName}
                        </span>
                      </Col>
                    )}
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Contact Number
                      </span>
                      <span className="user-info">
                        {bookingDetails.user?.countryCode}{" "}
                        {bookingDetails.user?.phone}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Email
                      </span>
                      <span className="user-info">
                        {bookingDetails.user?.email
                          ? bookingDetails.user?.email
                          : "-"}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Address
                      </span>
                      <span className="user-info">
                        {bookingDetails.user?.address?.addressLine1}{" "}
                        {bookingDetails.user?.address?.addressLine2
                          ? ", " + bookingDetails.user?.address?.addressLine2
                          : ""}{" "}
                        {bookingDetails.user?.address?.landmark
                          ? ", " + bookingDetails.user?.address?.landmark
                          : ""}{" "}
                        , {bookingDetails.user?.address?.city} ,{" "}
                        {bookingDetails.user?.address?.state} ,{" "}
                        {bookingDetails.user?.address?.country} ,{" "}
                        {bookingDetails.user?.address?.pincode}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        GST No
                      </span>
                      <span className="user-info">
                        {bookingDetails.user?.gstNumber
                          ? bookingDetails.user?.gstNumber
                          : "-"}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Sports Name{" "}
                      </span>
                      <span className="user-info">
                        {bookingDetails.sportName}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Court Name
                      </span>
                      <span className="user-info">
                        {bookingDetails.courtName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Facilty Name
                      </span>
                      <span className="user-info">
                        {bookingDetails.facilityName}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Booked Date
                      </span>
                      <span className="user-info">
                        {bookingDetails.createdAt}
                      </span>
                    </Col>
                    <Col lg={12} className="gy-4">
                      <table className="table table-bordered ">
                        <thead>
                          <tr>
                            <th>Selected Date</th>
                            <th>Selected Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingDetails?.bookingSlots?.map((item: any) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.bookingDate}</td>
                                <td>
                                  {item.fromTime} to {item.toTime}
                                </td>
                                <td>
                                  {LableFromEnums(item.status, EnumArrObj)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Row className="text-end">
                <hr />
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Sub Total:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.subTotal?.toFixed(2)}
                  </span>
                </Col>
                {bookingDetails.discount > 0 && (
                  <Col md={{ span: 4, offset: 8 }}>
                    <span className="user-info-title text-info text-uppercase mb-2">
                      Discount:{" "}
                    </span>
                    <span className="user-info">
                      -<span className="rupees-symbol">&#8377;</span>
                      {bookingDetails.discount?.toFixed(2)}
                    </span>
                  </Col>
                )}

                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Tax ({totalTax?.toFixed(2)}%):{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.totalTax?.toFixed(2)}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Payable Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingDetails.totalAmount)}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Paid Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingDetails.totalPaidAmount)}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Balance Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(
                      bookingDetails.totalAmount -
                      bookingDetails.totalPaidAmount
                    )}
                  </span>
                </Col>
                <Col lg={12}>
                  <span className="d-block fst-italic fw-semibold mt-3">
                    <sup>*</sup>The Amount is inclusive of all the taxes
                  </span>
                </Col>
              </Row>
            </Row>
          </div>
        </Card.Body>
      </Card>
      <ToastContainer />
    </Container>
  );
};
export { CourtsBookingSummary };
